export function renderUniqueId(id) {
  return `${id}${Math.random() * 1000.1421}`;
}
